import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import login from '@/router/routes/login';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...login,
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        protected: true,
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/call/:id/waiting-room',
      name: 'waiting-room',
      component: () => import('@/views/waitingRoom/WaitingRoom.vue'),
      props: true,
      meta: {
        protected: true,
        pageTitle: 'Waiting Room',
      },
    },
    {
      path: '/call/:id/live',
      name: 'live-call',
      component: () => import('@/views/liveCall/LiveCall.vue'),
      meta: {
        protected: true,
        pageTitle: 'Live Call',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/electron',
      name: 'electron-setup',
      component: () => import('@/views/electronSetup/ElectronSetup'),
      meta: {},
    },
  ],
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('userTokenOffsite');

  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  const loggedIn = !!token;
  // Authed routes that do not allow unauthed users
  if (!loggedIn && to.meta.protected) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  // UnAuthed routes that do not allow authed users
  if (loggedIn && to.meta.redirectAuthed) {
    next({
      path: '/dashboard',
    });
  }
  next();
});

export default router
